import SelectBase from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import classNames from "classnames";

const BootstrapSelect = styled(SelectBase)(({ theme }) => ({
  // Use the system font instead of the default Roboto font.
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  "&:before": {
    display: "none",
  },
  "&:after": {
    display: "none",
  },
  "& .MuiSelect-nativeInput": {
    border: "none",
  },
  "& .MuiSelect-nativeInput:placeholder": {
    color: "#AFC0D5",
  },
  "& .MuiSelect-select": {
    backgroundColor: "transparent !important",
    paddingTop: 0,
    paddingBottom: 0,
  },
  "&.Mui-focused": {
    backgroundColor: "white !important",
    border: "1px solid #ff2800",
  },
  "& .MuiSelect-icon": {
    color: "black",
    right: 18,
  },
}));

const placeholderValue = "_placeholderValue__";

export const Select = ({
  className = "",
  options = [],
  placeholder,
  value = "",
  maxWidth = 140,
  disabled = false,
  ...rest
}) => {
  value = value || placeholderValue;

  console.log("value", value);

  return (
    <BootstrapSelect
      className={classNames(
        "w-full h-[56px] px-[12px] bg-[#f5f7fa] border text-[14px] font-normal border-solid border-transparent rounded-full",
        {
          "text-[#AFC0D5]": value === placeholderValue,
          "hover:border-[#ff2800] hover:bg-white": !disabled,
        },
        className
      )}
      variant="filled"
      value={value}
      MenuProps={{ style: { maxHeight: 400 } }}
      disabled={disabled}
      {...rest}
    >
      {placeholder && (
        <MenuItem disabled value={placeholderValue}>
          {placeholder}
        </MenuItem>
      )}
      {Array.isArray(options) &&
        options.map((option, i) => {
          return (
            <MenuItem
              key={i}
              value={option.value}
              className="text-[14px] font-normal"
            >
              <div className="truncate" style={{ maxWidth }}>
                {option.label}
              </div>
            </MenuItem>
          );
        })}
    </BootstrapSelect>
  );
};
